<template>
  <div id="about-show">
    <page-not-ready />
  </div>
</template>

<script>
export default {
  name: 'AboutShow',
  metaInfo: {
    title: 'About OK K.O.!'
  }
}
</script>
